/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateBeamShapingGroupCircularDto } from './CreateBeamShapingGroupCircularDto';
import {
    instanceOfCreateBeamShapingGroupCircularDto,
    CreateBeamShapingGroupCircularDtoFromJSON,
    CreateBeamShapingGroupCircularDtoFromJSONTyped,
    CreateBeamShapingGroupCircularDtoToJSON,
} from './CreateBeamShapingGroupCircularDto';
import type { CreateBeamShapingGroupRectangularDto } from './CreateBeamShapingGroupRectangularDto';
import {
    instanceOfCreateBeamShapingGroupRectangularDto,
    CreateBeamShapingGroupRectangularDtoFromJSON,
    CreateBeamShapingGroupRectangularDtoFromJSONTyped,
    CreateBeamShapingGroupRectangularDtoToJSON,
} from './CreateBeamShapingGroupRectangularDto';

/**
 * @type CreateBeamShapingGroupDto
 * 
 * @export
 */
export type CreateBeamShapingGroupDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateBeamShapingGroupCircularDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared' } & CreateBeamShapingGroupRectangularDto;


export function CreateBeamShapingGroupDtoFromJSON(json: any): CreateBeamShapingGroupDto {
    return CreateBeamShapingGroupDtoFromJSONTyped(json, false);
}

export function CreateBeamShapingGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBeamShapingGroupDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateBeamShapingGroupCircularDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, CreateBeamShapingGroupRectangularDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of CreateBeamShapingGroupDto exists with '$type=${json['$type']}'`);
    }
}

export function CreateBeamShapingGroupDtoToJSON(value?: CreateBeamShapingGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateBeamShapingGroupCircularDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared':
            return CreateBeamShapingGroupRectangularDtoToJSON(value);
        default:
            throw new Error(`No variant of CreateBeamShapingGroupDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the CreateBeamShapingGroupDto interface.
 */
export function instanceOfCreateBeamShapingGroupDto(value: any): value is CreateBeamShapingGroupDto {
    if (instanceOfCreateBeamShapingGroupCircularDto(value)) return true;
    if (instanceOfCreateBeamShapingGroupRectangularDto(value)) return true;
    return false;
}

